import React from 'react';

import Tabs from '../../components/Tabs';
import {INVENTORY_PATH, EXCEPTIONS_PATH} from './paths';

//Balances and Exceptions as header tabs, the same way Users and User Groups share one screen
function InventoryTabs({view}) {
  return (
    <Tabs>
      <Tabs.Tab active={view === 'balances'} to={INVENTORY_PATH}>Balances</Tabs.Tab>
      <Tabs.Tab active={view === 'exceptions'} to={EXCEPTIONS_PATH}>Exceptions</Tabs.Tab>
    </Tabs>
  );
}

export default InventoryTabs;
